
import { useNavigate } from "react-router";
import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { HomePage } from "../views/home/HomePage";
import { useEffect } from "react";

const Home=()=>{
    const navigate = useNavigate();

    useEffect(() => {
       if (localStorage.getItem("role") == "admin") {
        navigate("/admin/prompts");
       }
    }, []);

    window.scrollTo(0, 0);
    
    return(
        <>
        <Header/>
        <HomePage/>
        <Footer/>
        </>
    )
}


export default Home;